import React from "react";
import "../static/index.css";
import AndroidIcon from "../../Home/static/images/androidPlayIcon.png";
import bannerGif from "../static/images/bannerGif3.gif";
import { Helmet } from "react-helmet";
function Body() {
  return (
    // <div className="homepageBody d-flex flex-column justify-content-center align-items-center">
    //   <div className="contactUsPoster"></div>
    // </div>
    <div className="contactUsPoster pb-sm-2 pb-2">
      <Helmet>
        <title>Contact Us Page</title>
      </Helmet>
      <div className="row flex-row justify-content-center align-items-center">
        <div className="contactUsText col-xl-custom-4 col-lg-custom-4 col-md-custom-4 col-sm-12 col-12 px-xl-0 px-lg-0 px-md-0 px-sm-3 px-3  py-xl-0 py-lg-0 py-md-0 pt-sm-3 pt-3 ">
          Ombré for
        </div>
        <img
          className="bannerGif col-xl-4 col-lg-4 col-md-4 col-sm-7 col-7 p-0 mr-auto"
          src={bannerGif}
          alt="banner gif"
        />
      </div>
      <div className="needHelpContainer d-none d-xl-block d-lg-block d-md-block">
        <div className="needHelp text-center mt-xl-3 mt-md-3 mt-lg-3">
          Partner with Ombre
        </div>
        <div className="needHelp col-xl-8 col-lg-8 col-md-8 m-auto p-0 text-center">
          Get connected to a large influencer community and fans.
        </div>
      </div>
      <div className="d-none d-xl-none d-lg-none d-md-none d-sm-block d-block">
        <div className="d-flex flex-row downloadButtonsContainer mt-sm-4 mt-4 pb-xl-5 pb-lg-5 pb-md-3 pb-sm-3 pb-3  pl-sm-2 pl-2">
          <div className="androidButton bg-white d-flex flex-row px-sm-3 px-3 py-1 mr-4">
            <img
              className="downloadIcon"
              src={AndroidIcon}
              alt="Android Play Icon"
            />
            <div className="androidButtonText ml-sm-2 ml-2 my-auto">
              Android
            </div>
          </div>
          <div className="iosButton d-flex flex-row bg-white px-sm-3 px-3 py-1">
            <i className="fab fa-apple appleIcon"></i>
            <div className="iosButtonText my-auto ml-lg-3 ml-lg-3 ml-md-3 ml-sm-2 ml-2">
              iOS
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Body;



// WEBPACK FOOTER //
// ./src/pages/ContactUs/components/Body.jsx